import React, { useEffect, useRef, useState } from 'react';
import * as S from './styles';
import { useMessage } from 'newComponents/ChatWhatsapp/context/MessageContext';
import { CircularProgress, FormControlLabel} from '@material-ui/core';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import NewPhoneModal from './NewPhoneModal';
import PhoneCallModal from './PhoneCallModal';
import { formatPhoneNumber } from 'util/utils';
import { getProfileType } from 'util/isAdmin';

const PhoneNumbersManager = () => {
	const {
		phoneNumbers,
		isPhoneNumbersLoading,
		handleCreateSession,
		isNewPhoneNumberModalOpen,
		setIsNewPhoneNumberModalOpen,
		handleTogglePhoneNumberStatus,
		handleTogglePhoneNumberJustReceptive,
		setSubSessionToHandle
	 } = useMessage();
	const isAdmin = getProfileType() === 1;
	const [ newPhoneNumberModalPosition, setNewPhoneNumberModalPosition ] = useState( { top: 0, left: 0 } );
	const [ isPhoneCallModalOpen, setIsPhoneCallModalOpen ] = useState( false );
	const [ isCreatingSession, setIsCreatingSession ] = useState( false );
	const [ phoneCallModalData, setPhoneCallModalData ] = useState( null );

	const anchorRef = useRef( null );
	const handleOpenNewPhoneNumberModal = async () => {
		// AFCO-417: sem esse guard, cada clique repetido abria uma nova geração de
		// QR Code no bailey-api e derrubava a anterior.
		if ( isCreatingSession ) {
			return;
		}
		setIsCreatingSession( true );
		if ( anchorRef.current ) {
			const rect = anchorRef.current.getBoundingClientRect();
			setNewPhoneNumberModalPosition( {
				top  : rect.bottom + window.scrollY,
				left : rect.left + window.scrollX
			} );
		}
		// O modal abre antes da chamada para o usuário ver o carregamento no
		// instante do clique. Antes ele só abria depois da resposta, e era nessa
		// janela sem retorno visual que o usuário clicava várias vezes.
		setSubSessionToHandle( null );
		setIsNewPhoneNumberModalOpen( true );
		try {
			await handleCreateSession();
		} finally {
			setIsCreatingSession( false );
		}
	};

	const handlerTogglePhoneNumberStatus = async ( phoneData ) => {
		if(!phoneData.isActive) {
			await handleTogglePhoneNumberStatus( phoneData.id );
		}
		setSubSessionToHandle( phoneData );
		setIsNewPhoneNumberModalOpen( true );
	};

	const handlerTogglePhoneNumberJustReceptive = async ( phoneData ) => {
		await handleTogglePhoneNumberJustReceptive( phoneData.id );
	};

	const handlerToggleStatusPhoneCall = ( phoneData ) => {
		setPhoneCallModalData( phoneData );
		setIsPhoneCallModalOpen( true );
	};

	const handleClosePhoneCallModal = () => {
		setIsPhoneCallModalOpen( false );
		setPhoneCallModalData( null );
	};

	useEffect( () => {
		if ( !isPhoneCallModalOpen || !phoneCallModalData ) return;
		const currentPhone = phoneNumbers.find( ( p ) => p.id === phoneCallModalData.id );
		if ( currentPhone && currentPhone.phoneCallIsActive !== phoneCallModalData.phoneCallIsActive ) {
			handleClosePhoneCallModal();
		}
	}, [ phoneNumbers, isPhoneCallModalOpen, phoneCallModalData ] );

	return (
		<S.PhoneNumbersManagerContainer>
			{isNewPhoneNumberModalOpen && <NewPhoneModal
				position={newPhoneNumberModalPosition}
				modalRef={anchorRef}
			/>}
			{isPhoneCallModalOpen && phoneCallModalData && (
				<PhoneCallModal
					phoneData={phoneCallModalData}
					onClose={handleClosePhoneCallModal}
				/>
			)}
			<S.HeaderContainer>
				<S.MainTitle>Telefones</S.MainTitle>
				<S.Subtitle>Configure seus telefones</S.Subtitle>
			</S.HeaderContainer>
			<S.PhoneNumbersContent>
				<S.TitleContainer>
					<S.ButtonAddPhoneNumber onClick={handleOpenNewPhoneNumberModal} disabled={isCreatingSession || isNewPhoneNumberModalOpen}>
						<AddCircleOutlineIcon />
					</S.ButtonAddPhoneNumber>
				</S.TitleContainer>
				{isPhoneNumbersLoading ? (
					<S.PhoneNumbersLoading>
						<CircularProgress />
					</S.PhoneNumbersLoading>
				) : (
					<S.PhoneNumbersTable>
						<S.PhoneNumbersTableHead>
							<S.PhoneNumbersHeaderContainer>
								<S.PhoneNumbersHeaderItem>Data de criação</S.PhoneNumbersHeaderItem>
								<S.PhoneNumbersHeaderItem>Contato</S.PhoneNumbersHeaderItem>
								<S.PhoneNumbersHeaderItem>Conectado</S.PhoneNumbersHeaderItem>
								<S.PhoneNumbersHeaderItem>Apenas receptivo</S.PhoneNumbersHeaderItem>
								<S.PhoneNumbersHeaderItem>Pode realizar chamadas</S.PhoneNumbersHeaderItem>
							</S.PhoneNumbersHeaderContainer>
						</S.PhoneNumbersTableHead>
						<S.PhoneNumbersTableBody>
						{phoneNumbers.map( ( phoneData ) => (
							<S.PhoneNumbersItem key={phoneData.id}>
								<S.PhoneNumbersItemTitle>{phoneData.createdAt}</S.PhoneNumbersItemTitle>
								<S.PhoneNumbersItemTitle>{formatPhoneNumber(phoneData.phoneNumber)}</S.PhoneNumbersItemTitle>
								<S.PhoneNumbersItemActions>
									<FormControlLabel
											control={
												<S.GreenSwitch
													checked={phoneData.isActive}
													onChange={() => handlerTogglePhoneNumberStatus( phoneData )}
													value={phoneData.isActive}
													/>
												}/>
								</S.PhoneNumbersItemActions>
								<S.PhoneNumbersItemActions>
									<FormControlLabel
											control={
												<S.GreenSwitch
													checked={phoneData.isJustReceptive}
													onChange={() => handlerTogglePhoneNumberJustReceptive( phoneData )}
													value={phoneData.isJustReceptive}
													disabled={!isAdmin}
													/>
												}/>
								</S.PhoneNumbersItemActions>
								<S.PhoneNumbersItemActions>
									<FormControlLabel
											control={
												<S.GreenSwitch
													checked={phoneData.phoneCallIsActive}
													onChange={() => handlerToggleStatusPhoneCall( phoneData )}
													value={phoneData.phoneCallIsActive}
													/>
												}/>
								</S.PhoneNumbersItemActions>
							</S.PhoneNumbersItem>
						) )}
						</S.PhoneNumbersTableBody>
					</S.PhoneNumbersTable>
					)}
			</S.PhoneNumbersContent>
		</S.PhoneNumbersManagerContainer>
	);
};

export { PhoneNumbersManager };